import RouteCheckerTo from '@/views/route-checker';
import AgreementLimitsView from './agreement-limits.view.vue';

export default [
  {
    path: '/agreement-limits',
    name: 'Limites de Remuneração',
    component: AgreementLimitsView,
    beforeEnter: RouteCheckerTo.isAdmin,
  },
];
